// import router from '@/router/index';
import { getOpenIdByCode, getTokenByOpenId, wxLogin } from './api/wx';
import { getOpenId } from './utils/auth';
import { useUserStore } from '@/pinia/user';
import { NavigationGuardNext, RouteLocationNormalized, Router } from 'vue-router';
import APP_CONFIG from './APP_CONFIG';
import { useToast } from './hooks/useToast';
const wList = ['/review', '/register', '/clause', '/404', '/bind'];
const payPage = [
  '/eva/evaluate',
  '/eva/result',
  '/eva/reward',
  '/eva/edu',
  '/eva/thesis',
  '/eva/book',
  '/eva/patent',
  '/eva/project',
  '/eva/year_check',
];
const ENV = APP_CONFIG.ENV;
/**
 * @description 白名单不需要授权token
 * @description token 是判断是否绑定身份证的唯一标准
 */

export function installAuth(router: Router) {
  router.beforeEach(async (to, from, next) => {
    const Toast = useToast();

    // 白名单
    if (wList.includes(to.path)) {
      return next();
    }
    if (to.path == '/complist') {
      if (ENV == 'development') {
        checkPay(to, from, next);
      } else {
        next({
          path: '/404',
          replace: true,
        });
      }
      return;
    }
    const user = useUserStore();

    // 本地保存了 openid 则设置 store
    const hasLsOpenId = getOpenId() && getOpenId() != '' && getOpenId() != null && getOpenId() != 'null';
    if (!user.hasOpenId && hasLsOpenId) {
      user.setUserOpenId(getOpenId() as string);
    }

    if (user.hasOpenId) {
      // 本地开发环境，已经在 utils/handleEnv.ts 设置了 token 和 openid ，跳过微信授权
      if (ENV == 'development') {
        return await getRouterUserInfo(to, from, next);
      }

      // store 设置了 token ，表示已经绑定了身份证，直接获取用户信息
      if (user.isLogin) {
        await getRouterUserInfo(to, from, next);
        return;
      }

      // 否则，根据 openid 获取 token
      await getTokenByOpenId(user.openid).then(async (res) => {
        // 如果 res.data.token 不为空，则设置 store.token，然后获取用户信息
        if (res.data.token && res.data.token != null && res.data.token != '') {
          user.setUserToken(res.data.token as string);
          await getRouterUserInfo(to, from, next);
          return;
        }

        // 如果 store.token 不存在，则进行绑定
        if (!user.isLogin) {
          if (to.path != '/bind') {
            next({ path: '/bind', query: { from: to.path, ...to.query } });
          } else {
            checkPay(to, from, next);
          }
        } else {
          // 否则直接获取 用户信息
          await getRouterUserInfo(to, from, next);
        }
      });
      return;
    }

    // 授权
    // 链接包含 code 参数则进行授权
    if (to.query.code) {
      await authByCode(to, from, next);
    } else {
      // 否则请求 wxlogin
      await handleGetOpenId();
      Toast.loading!('加载中...');
    }
  });
}

/**
 * @description 请求微信授权地址
 * @returns
 */
function handleGetOpenId() {
  // 获取当前地址的所有参数，保证微信授权重定向回来可以继续用户点进来的操作。
  const url = window.location.href;
  return wxLogin(url).then((res) => {
    if (ENV == 'production') {
      setTimeout(() => {
        window.location.href = res.data.url;
      }, 500);
    }
  });
}

/**
 * @description 根据微信返回的 code 换取 openid
 * @param to
 * @param from
 * @param next
 * @returns
 */
function authByCode(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  const user = useUserStore();
  return getOpenIdByCode(to.query.code as string).then(async (res) => {
    if (res.data.token && res.data.token != '' && res.data.token != null) {
      user.setUserToken(res.data.token);
    }
    user.setUserOpenId(res.data.openid);
    if (!user.isLogin && to.path != '/bind') {
      next({ path: '/bind', query: { from: to.path, ...to.query } });
    } else {
      await getRouterUserInfo(to, from, next);
    }
  });
}

/**
 * @description 获取用户信息设置 store.user
 * @param to
 * @param from
 * @param next
 * @returns
 */
function getRouterUserInfo(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) {
  const user = useUserStore();
  return new Promise<void>(async (resolve) => {
    const Toast = useToast();

    if (!user.hasUserInfo) {
      await user
        .getUserInfo()
        .then(() => {
          resolve();
          checkPay(to, from, next);
        })
        .catch(() => {
          localStorage.setItem('handleGetOpenId', 'not-user-info');
          handleGetOpenId();
          Toast.loading!('加载中...');
        });
    } else {
      resolve();
      // next();
      checkPay(to, from, next);
    }
  });
}

function checkPay(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  const user = useUserStore();
  if (payPage.includes(to.path)) {
    const jid = to.query?.jid as unknown as number;
    const isPay = user.payJurys.some((e) => e.juryId == jid);
    if (isPay) {
      next();
    } else {
      next({
        path: '/eva/pay',
        query: {
          jid,
          path: to.path,
        },
        replace: true,
      });
    }
  } else {
    next();
  }
}
